<template>
<div class="container-fluid">
    <div class="row">
        <Menu />
        <div class="col-md-10 mt-4">
            <h1>
                <i class="fa-solid fa-diagram-project"></i> Grupos Cadastrados      
                    <RouterLink style="float:right; position:relative; top:-10px;" to="/projeto/novo" class="btn btn-primary">+ NOVO</RouterLink>
                </h1> 
                <hr />
            <div class="cont mt-4">
            <table class="table">
                        <thead>
                            <tr>
                                <th scope="col">Nome do grupo</th>
                                <!-- <th scope="col">Situação</th> -->
                                <th scope="col">Visualizar</th>
                                <th scope="col">Excluir</th>
                            </tr>
                        </thead>
                        <tbody v-if="dados.length > 0">
                            <tr v-for="reck in dados" :key="reck.id">
                                <td>{{ reck.name }}</td>
                                <!-- <td>{{ reck.situacao }}</td> -->
                                <td><i @click="visualizar(reck.id)" style="cursor: pointer;" class="fa-sharp fa-light fa-eye"></i></td>
                                <td><i @click="remove_projeto(reck.id)"  style="cursor: pointer;" class="fa-light fa-trash"></i></td>
                            </tr>                            
                        </tbody>
                        <tbody v-else>
                            <tr><div class="alert alert-warning mt-4">Nenhum grupo cadastrado</div></tr>
                        </tbody>
                    </table>
                </div>
        </div>
    </div>
</div>
</template>
<script setup>
import { ref , onMounted} from "vue";
import Menu from "@/components/Menu.vue"
import projetos from '@/servicos/projetos'
import { useRouter } from "vue-router";
const dados = ref([])

const rotas = useRouter();

const buscaDados = async () => {
    try {
        const response =  await projetos.getAll()
        dados.value = response.data
    }catch(error){
        const response = error.response.data
    }
}

const remove_projeto = async (value) => {
    if(window.confirm("Deseja realmente excluir esse projeto? Essa ação não será revertida")){
        const response = await projetos.deleteProjeto(value)
        buscaDados()
    }
}

const visualizar = (id) => {
    rotas.push(`/projeto/${id}`)
}

onMounted(()  => {
    buscaDados()
})


</script>
<style></style>
